




















import { Vue, Component, Prop } from "vue-property-decorator";
import { Family, CompanyFamily } from "@/models";
import Percent from "@/filters/Percent";

//TODO : rivedere allineamento sconto totale

@Component({ filters: { Percent } })
export default class CatalogueListItem extends Vue {
  @Prop({ required: true }) value!: CompanyFamily;

  get discount() {
    let discString = Percent(`${this.value.discount}`);
    discString = this.value.additionalDiscounts
      .map((d) => this.formatPercent(d))
      .reduce((a, b) => {
        a = `${a} + ${b}`;
        return a;
      }, discString);
    return discString;
  }

  get description() {
    return this.value.family?.descriptionEn;
  }

  get iconSrc() {
    return this.value.family?.iconUrl;
  }

  private formatPercent(discount: number) {
    return Percent(`${discount}`);
  }

  onEdit() {
    this.notifyEdit();
  }

  notifyEdit() {
    this.$emit("edit", this.value);
  }
}
